export class MarkToMarketSettingApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getSetting() {
    return this.#http.get('/markToMarketSetting');
  }

  async editSetting(body) {
    return this.#http.put('/markToMarketSetting', body);
  }
}
